import { render, staticRenderFns } from "./FormModules.vue?vue&type=template&id=64249c75&scoped=true&"
import script from "./FormModules.vue?vue&type=script&lang=js&"
export * from "./FormModules.vue?vue&type=script&lang=js&"
import style0 from "./FormModules.vue?vue&type=style&index=0&id=64249c75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64249c75",
  null
  
)

export default component.exports